/**
 * Microsoft brand mark — the four-color square grid used on Microsoft
 * sign-in surfaces (red top-left, green top-right, blue bottom-left,
 * yellow bottom-right). Same shape as `GoogleIcon.tsx` — inline SVG,
 * brand-accurate colors, decorative-by-default (`aria-hidden`).
 *
 * Squares fill the full 24×24 viewBox with a 2-unit center gap so the
 * mark stays recognisable at the 16×16 display size the OAuth row
 * uses. The earlier 10×10-with-margins version rendered as four tiny
 * dots at icon size and read as a blank button — see #1041.
 */
export function MicrosoftIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="0" y="0" width="11" height="11" fill="#f25022" />
      <rect x="13" y="0" width="11" height="11" fill="#7fba00" />
      <rect x="0" y="13" width="11" height="11" fill="#00a4ef" />
      <rect x="13" y="13" width="11" height="11" fill="#ffb900" />
    </svg>
  )
}
